import type { PackPurchaseResponse } from './types';
import { toNumber } from './numberUtils';

export type RawPackPurchaseResponse = Partial<PackPurchaseResponse> & {
  remaining_wallet_balance?: number | string | null;
  new_wallet_balance?: number | string | null;
  wallet_new_balance?: number | string | null;
  auto_activated?: boolean | null;
  activated?: boolean | null;
  status?: string | null;
  message?: string | null;
  pack_id?: string | null;
};

export const normalizePackPurchaseResponse = (
  response: RawPackPurchaseResponse
): PackPurchaseResponse => {
  const rawBalance = response.remaining_wallet_balance
    ?? response.new_wallet_balance
    ?? response.wallet_new_balance;

  return {
    pack_id: response.pack_id ?? '',
    status: (response.status ?? '').toLowerCase(),
    remaining_wallet_balance: toNumber(rawBalance),
    auto_activated: response.auto_activated ?? response.activated ?? false,
    message: response.message ?? 'Pack purchased successfully',
  };
};
